/* unplugin-vue-components disabled */import script from "./StudyMaterialDetailRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyMaterialDetailRight.vue?vue&type=script&setup=true&lang=ts"

import "./StudyMaterialDetailRight.vue?vue&type=style&index=0&id=ef02fa6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef02fa6a"]])

export default __exports__